const API_BASE_URL =
  process.env.REACT_APP_API_URL || "";

function getStoredUser() {
  const storedUser =
    localStorage.getItem("user") ||
    localStorage.getItem("localUser");

  if (!storedUser) {
    return null;
  }

  try {
    return JSON.parse(storedUser);
  } catch {
    return null;
  }
}

function getUserId() {
  const user = getStoredUser();

  return user?.id || null;
}

function getHeaders() {
  const userId = getUserId();

  return {
    "Content-Type": "application/json",
    ...(userId
      ? {
          "X-User-ID": String(userId),
        }
      : {}),
  };
}


// =========================================================
// GET APPEARANCE
// =========================================================

export async function getAppearance() {

  const response = await fetch(
    `${API_BASE_URL}/api/appearance`,
    {
      method: "GET",
      headers: getHeaders(),
    }
  );

  if (!response.ok) {

    const errorText =
      await response.text();

    throw new Error(
      errorText ||
      "Failed to load appearance."
    );
  }

  return response.json();
}


// =========================================================
// SAVE APPEARANCE
// =========================================================

export async function saveAppearance(
  themeKey
) {

  const response = await fetch(
    `${API_BASE_URL}/api/appearance`,
    {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify({
        theme_key: themeKey,
      }),
    }
  );

  if (!response.ok) {

    const errorText =
      await response.text();

    throw new Error(
      errorText ||
      "Failed to save appearance."
    );
  }

  return response.json();
}